<template>
    <MenuBaseSubmenu :listenerId="listenerId" ref="overlayPanel">
        <a href="//help.keys.so">
            <i class="ksi ksi-help"></i>
            <span>{{ $t('lang.menu.help') }}</span>
        </a>
        <a :href="getDocUrl">
            <i class="ksi ksi-api"></i>
            <span>{{ $t('lang.menu.api') }}</span>
        </a>
        <a href="//blog.keys.so">
            <i class="ksi ksi-blog"></i>
            <span>{{ $t('lang.menu.blog') }}</span>
        </a>
        <a href="//help.keys.so/faq">
            <i class="ksi ksi-faq"></i>
            <span>{{ $t('lang.menu.faq') }}</span>
        </a>
        <a v-if="isShowSupport" href="#" @click.prevent="onOpenSupport">
            <i class="pi pi-user"></i>
            <span>{{ $t('lang.menu.support') }}</span>
        </a>
        <a href="#" @click.prevent="onOpenDemo">
            <i class="pi pi-video"></i>
            <span>{{ $t('lang.menu.demo') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "keysso/constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Verbox from "keysso/mixins/Verbox";

export default {
    name: "MenuSubmenuTopHelp",
    mixins: [Verbox],
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_HELP_HOVER,
            showSupport: false,
        };
    },
    mounted() {
        this.$emitter.on(Listeners.GLOBAL_STORE_GET_USER, (user) => {
            this.showSupport = !user.elamaId;
        });
    },
    computed: {
        getDocUrl() {
            return this.$config.DOC_API_URL;
        },
        isShowSupport() {
            return this.showSupport;
        }
    },
    methods: {
        onOpenDemo() {
            this.$refs.overlayPanel.$refs.overlayPanel.hide();
            this.$emitter.emit(Listeners.POPUP_DEMO_BLOCK_OPEN);
        },
        onOpenSupport() {
            this.$refs.overlayPanel.$refs.overlayPanel.hide();
            this.onOpenVerbox();
        },
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>

<style scoped>
.pi-user {
    font-size: 14px !important;
    margin-right: 2px;
    margin-left: 2px;
}
.pi-video {
    font-size: 14px !important;
    margin-left: 1px;
    margin-right: 3px;
}
</style>
